import { Button, Checkbox, message } from 'antd';
import { Input } from 'antd';
import './style.scss';
import { useGoogleLogin } from '@react-oauth/google';
import { useNavigate, Link, useSearchParams } from 'react-router-dom';
import { SignInApi } from '../../../apis/SignIn';
import { useEffect, useState } from 'react';
import metaModelLogo from '../../../Images/sidebar/Logo_MetaModel.svg';
import { useCookies } from 'react-cookie';
import useAuthContext from '../../../hooks/useAuthContext';
import { useDispatch } from 'react-redux';
import { resetForStepWiseUserData } from '../../../redux/Reducers/userStepsDataDetailReducer';

const Login = () => {
  let navigate = useNavigate();
  const [rememberMe, setRememberMe] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [cookies, setCookie] = useCookies(['email', 'password']);
  const [errorMsg, setErrorMsg] = useState('');
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const { userState, dispatcher } = useAuthContext();
  const [searchParams] = useSearchParams();
  const [lead, setLead] = useState('');

  const dispatch = useDispatch();

  // const leadId = searchParams.get('leadId');

  useEffect(() => {
    if (cookies.__MM__UE && cookies.__MM__UP ) {
      setEmail(atob(cookies.__MM__UE));
      setPassword(atob(cookies.__MM__UP)); // Decoding Base64 password
      setRememberMe(true);
    }
  }, [cookies]);

  // useEffect(()=>{
  //   localStorage.setItem('leadId', leadId);
  //   setLead(lead);
  // },[searchParams, window.location])


  useEffect(() => {
    const leadIdFromUrl = searchParams.get('leadId');
    const persistedLeadId = localStorage.getItem('leadId');

    if (leadIdFromUrl !== null && leadIdFromUrl !=='null') {
      // Store the new leadId from URL in localStorage
      localStorage.setItem('leadId', leadIdFromUrl);
    } else if (!persistedLeadId) {
      // If there's no leadId in URL and localStorage, you can set a default or do nothing
      console.log('No leadId found in URL or localStorage.');
    }
  }, [searchParams]);

  const leadId = searchParams.get('leadId') || localStorage.getItem('leadId');
 

  const googleLogin = useGoogleLogin({
    flow: 'implicit',
    onSuccess: async (credentialResponse) => {
      const response = await SignInApi.getCredsGoogleLogin(credentialResponse);
      console.log(credentialResponse);
      let obj = {
        email: response.data.email,
        name: response.data.name,
        distributorId:
          sessionStorage.getItem('mm:dbId') || '663b39b3ab4ec46c6ebcf259',
        accessToken: credentialResponse.access_token,
        firstName: response.data.given_name,
        lastName: response.data.family_name,
        isInternalUser:false
        
      };
      if(leadId !== null && leadId !=='null'){
        obj.leadId = leadId;
      }
      console.log(response);
      const userResponse = await SignInApi.userGoogleLogin(obj);
      if (userResponse.status === 200) {
        let user = {
          userEmail: obj.email,
          userName: obj.name,
          userToken: userResponse.data.token,
        };
        

        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', userResponse.data.token);
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        dispatch(resetForStepWiseUserData({}));
        navigate('/');
      }
    },
  });
  const handleUserLogin = async (e) => {
    e.preventDefault();
    if (!email.trim() || !password.trim()) {
      message.error('Please enter all the value');
      return;
    }
    if (!emailRegex.test(email)) {
      setErrorMsg('Please enter correct email');
      return;
    }
    try {
      let payload = {
        email: email,
        password: password,

      };
      if(leadId){
        payload.leadId = leadId;
      }
      const result = await SignInApi.loginUser(payload);
      if (result?.status == 200) {
        if (rememberMe) {
          setCookie('__MM__UE', btoa(email), {
            path: '/',
            secure: true,
            maxAge: 3600,
          });

          setCookie('__MM__UP', btoa(password), {
            path: '/',
            secure: true,
            maxAge: 3600,
          });
        } else {
          setCookie('__MM__UE', '', { path: '/' });
          setCookie('__MM__UP', '', { path: '/' });
        }
        let user = {
          userEmail: email,
          userName: email,
          userToken: result.data.token,
        };

       
        dispatcher({
          type: 'LOGIN',
          payload: user,
        });
        localStorage.setItem('mm:user', JSON.stringify(user));
        localStorage.setItem('metamodel_token', result.data.token);
        dispatch(resetForStepWiseUserData({}));
        navigate('/');
      }
      if (result?.response?.status == 403) {
        message.error(
          result.response.data.message || 'Please try again later.'
        );
      }
    } catch (err) {
      const errMsg = JSON.parse(err.response.data).message;
      message.error(errMsg || 'Please try again later.');
    }
  };
  const getMetaModelLogo = () => {
    return (
      <div className="logo_line">
        {/* <img src={metaModelLogo} alt="logo" onClick={() => navigate('/')} /> */}
      </div>
    );
  };
  const getGoogleLogin = () => {
    return (
      <div className="google_login_line">
        <Button className="google_login_btn" onClick={googleLogin}>
          {/* <img
            src="./../../Images/google_logo.svg"
            alt="googleIcon"
            className="google_icon"
          /> */}
          <p> Login with Google</p>
        </Button>
      </div>
    );
  };
  const getLoginForm = () => {
    return (
      <>
        <div className="user_email">
          <Input
            type="email"
            id="email"
            name="email"
            onChange={(e) => {
              setEmail(e.target.value);
              setErrorMsg('');
            }}
            placeholder="Your email"
            required
            className="email_input"
            value={email}
          />
          {errorMsg && <div className="error">{errorMsg}</div>}
        </div>
        <div className="user_password">
          <Input.Password
            placeholder="Enter Password"
            required
            className="password_input"
            name="password"
            onChange={(e) => {
              setPassword(e.target.value);
            }}
            onPressEnter={handleUserLogin}
            value={password}
          />
        </div>
        <div className="remember_forgot">
          <Checkbox
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
          >
            Remember me
          </Checkbox>
          <Link to="/forgot-password" className="forgot_password">
            Forgot Password?
          </Link>
        </div>
        <div className="continue_btn_line">
          <Button
            className={`continue_btn ${email.trim() && password.trim() ? '' : 'disable_btn'
              }`}
            onClick={handleUserLogin}
            type="submit"
            disabled={email.trim() && password.trim() ? false : true}
          >
            <p> Login </p>
          </Button>
        </div>
      </>
    );
  };

  return (
    <div className="login_wrapper">
      <div className="direction">
        {getMetaModelLogo()}

        <div className="direction_line_1">Welcome</div>
        <div className="direction_line_2">Login to continue</div>
        {getGoogleLogin()}
        <div className="direction_line_3">
          Or login using your email address
        </div>
        {getLoginForm()}
      </div>
      <div className="direction_line_4">
        New User? <Link to="/signup">Create an account</Link>
      </div>
    </div>
  );
};

export default Login;
